import React from 'react';
import { Divider, GridItem, Link, Skeleton, Text, useBreakpointValue, useDisclosure, } from '@chakra-ui/react';
import { DEFAULT_VALUE } from '../../../../../services/text/optionalValue';
import { useTokens } from '../../../../../context/TokenProvider';
import EPCChart from '../../../../modules/EPC/EPCChart';
import { energyRatingChartConfig, environmentImpactChartConfig, } from '../../../../../constants/EpcChartsConfig';
import { RenderIf } from '../../../../modules/RenderIf/RenderIf';
import EpcModal from '../../../../modules/EPC/EpcModal';
import { localise } from '../../../../../services/lang/lang';
const InspectionDetailPropertyAccordionEpcField = ({ epc, isLoading = false, }) => {
    const tokens = useTokens();
    const epcModal = useDisclosure();
    const isSmallScreen = useBreakpointValue({
        base: true,
        xl: false,
    });
    const shouldShowEPC = !!epc || isLoading;
    const shouldShowEpcCharts = !isSmallScreen && shouldShowEPC;
    const shouldShowEnergy = epc?.current_energy_rating != null ||
        epc?.potential_energy_rating != null ||
        isLoading;
    const shouldShowEnvironmental = epc?.environment_impact_current != null ||
        epc?.environment_impact_potential != null ||
        isLoading;
    return (React.createElement(React.Fragment, null,
        React.createElement(GridItem, { colSpan: shouldShowEpcCharts ? 2 : 1 },
            React.createElement(Text, { "data-testid": "skeleton_loading_field__title", variant: "dk-800-md-3" }, localise('EPC'))),
        React.createElement(RenderIf, { condition: !shouldShowEPC },
            React.createElement(Text, { variant: "md-600-rg-3" }, DEFAULT_VALUE)),
        React.createElement(RenderIf, { condition: !!isSmallScreen && shouldShowEPC },
            React.createElement(GridItem, null,
                React.createElement(Skeleton, { isLoaded: !isLoading },
                    React.createElement(Link, { onClick: epcModal.onOpen, cursor: "pointer" }, localise('SHOW'))))),
        React.createElement(RenderIf, { condition: !isSmallScreen },
            React.createElement(RenderIf, { condition: shouldShowEnergy },
                React.createElement(GridItem, { colSpan: 2 },
                    React.createElement(EPCChart, { isLoading: isLoading, title: localise('ENERGY_EFFICIENCY_RATING'), bands: energyRatingChartConfig, current: epc?.current_energy_rating, potential: epc?.potential_energy_rating }))),
            React.createElement(RenderIf, { condition: shouldShowEPC },
                React.createElement(GridItem, { colSpan: 2 },
                    React.createElement(Divider, { variant: "grey", my: tokens.Spacing02 }))),
            React.createElement(RenderIf, { condition: shouldShowEnvironmental },
                React.createElement(GridItem, { colSpan: 2 },
                    React.createElement(EPCChart, { isLoading: isLoading, title: localise('ENVIRONMENTAL_IMPACT_RATING'), bands: environmentImpactChartConfig, current: epc?.environment_impact_current, potential: epc?.environment_impact_potential })))),
        epcModal.isOpen && epc && (React.createElement(EpcModal, { onClose: epcModal.onClose, isOpen: epcModal.isOpen, epc: epc }))));
};
export default InspectionDetailPropertyAccordionEpcField;
